import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useInView } from 'react-intersection-observer';
import { selectIsBot } from '../../../selectors/ContextSelector';

/* istanbul ignore next */
const ScrollRenderer = ({ children, className, height, offset, loader }) => {
    const isBot = useSelector(selectIsBot);

    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: `${offset}px 0px ${offset}px 0px`,
    });

    const toRender = isBot || (inView && !__SERVER__);
    return (
        <div
            ref={ref}
            className={className}
            style={{
                height: toRender ? 'auto' : height,
                position: toRender ? 'unset' : 'relative',
            }}
        >
            {toRender ? children : loader}
        </div>
    );
};

ScrollRenderer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    className: PropTypes.string,
    height: PropTypes.number,
    offset: PropTypes.number,
    loader: PropTypes.symbol,
};

ScrollRenderer.defaultProps = {
    className: '',
    height: 300,
    offset: 2000,
    loader: null,
};

export default ScrollRenderer;
